/* eslint-disable */
import { ReactSVG } from 'react-svg';
import React from 'react';
import styles from './MajorJobsByDiscipline.module.css';
import classNames from 'classnames/bind';
import sitemapClasses from '../../css/sitemap.module.css';

let cx = classNames.bind(styles);

const MajorJobsByDiscipline = (props) => {
  const { isHomePage, majorIndustryList, isExplorePage } = props;

  return (
    <section
      className={classNames(
        'section',
        styles['industries-sec'],
        { '': isHomePage },
        { [sitemapClasses['siteMapTopLevelCareer']]: !isHomePage }
      )}
    >
      <div className="container">
        {isHomePage ? (
          <div className="col-lg-12 main_inner">
            <h2 className="brandonH2 sec-head pr-15">Major Jobs By Discipline</h2>
          </div>
        ) : isExplorePage ? (
          <div className="col-lg-12">
            <h2 className="sectionTitle brandonH1">Major Jobs By Discipline</h2>
          </div>
        ) : (
          <div className="col-lg-12">
            <h2 className="brandonH2 mt-3">Major Jobs By Discipline</h2>
          </div>
        )}
        <div className={`${styles['sec-body']} col-lg-12`}>
          <ul className="listWithIcons majorListWithIcons p-0">
            {majorIndustryList.map((major) => (
              <li key={major.majorName}>
                <a href={major.majorLink}>
                  <span className={`${cx(major.majorClasses.split(' '))} ${major.majorClasses}`}>
                    {major.svgLink && (
                      <i className={cx(major.majorClassesParent.split(' '))}>
                        <em>
                          <ReactSVG src={major.svgLink} />
                        </em>
                      </i>
                    )}
                  </span>
                  <span className="list-link industry-title">{`${major.majorName}`}</span>
                </a>
              </li>
            ))}
          </ul>
        </div>
        <div className={sitemapClasses['all-majors']}>
          <a style={{ color: '#3174ee' }} href="/majors/">
            All Majors
          </a>
        </div>
      </div>
    </section>
  );
};
export default MajorJobsByDiscipline;
